<!-- @format -->

<template>
	<div style="width: 100%">
		<disabled-text v-if="disabled && showDisabledText" :value="value" :show-tag="true" />
		<el-input
			v-else
			:model-value="value"
			placeholder="请选择用户"
			:disabled="disabled"
			clearable
			suffix-icon="ArrowDown"
			@click="onShowUser()"
			@clear="() => onConfirm('confirm', {})"
		/>
		<pcp-employee-selector-dialog
			:multiple="multiple"
			:visible="selectorVisible"
			:show-tree="false"
			@close="(visible) => (selectorVisible = visible)"
			@action-event="onConfirm"
		/>
	</div>
</template>

<script setup lang="ts">
	import DisabledText from './disabledText.vue';
	import { PcpEmployeeSelectorDialog } from '@/p-components';

	interface Props {
		modelValue: string;
		multiple?: boolean;
		showDisabledText?: boolean;
		disabled?: boolean;
		valueKey?: string;
	}

	const props = withDefaults(defineProps<Props>(), {
		modelValue: '',
		valueKey: 'id',
		showDisabledText: true,
	});

	const emit = defineEmits(['update:modelValue']);

	const selectorVisible = ref(false);

	const value = computed({
		get() {
			return props.modelValue;
		},
		set(value) {
			emit('update:modelValue', value);
		},
	});

	const onShowUser = () => {
		selectorVisible.value = true;
	};

	const onConfirm = (key, data) => {
		if (key === 'confirm') {
			if (props.valueKey) {
				value.value = data[props.valueKey];
				selectorVisible.value = false;
			}
		}
	};
</script>

<style lang="scss" scoped></style>
